export default "__VITE_ASSET__DRe01qHj__"